<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('settings_minor_application')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('settings_minor_application')"
                              :isFilter="false"/>
            </template>
            <ValidationObserver ref="settingForm">
                <b-row>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="semester_id" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('semester')">
                                <semesters-selectbox
                                    :validate-error="errors[0]"
                                    v-model="formData.semester_id">
                                </semesters-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="start_date" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('start_date')">
                                <b-form-input type="datetime-local" v-model="formData.start_date" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="end_date" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('end_date')">
                                <b-form-input type="datetime-local" v-model="formData.end_date" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="sms_message_tr" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('sms_message')+' TR'">
                                <b-form-input type="text" v-model="formData.sms_message_tr" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="sms_message_en" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('sms_message')+' EN'">
                                <b-form-input type="text" v-model="formData.sms_message_en" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="mail_message_tr" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('mail_message')+' TR'">
                                <ck-editor-input
                                    :validate-error="errors[0]"
                                    v-model="formData.mail_message_tr" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="mail_message_en" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('mail_message')+' EN'">
                                <ck-editor-input
                                    :validate-error="errors[0]"
                                    v-model="formData.mail_message_en" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12">
                        <b-button variant="primary" @click="saveSettings">{{$t('save')}}</b-button>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-between border rounded p-2 mt-4">
                        <b-button variant="secondary" @click="runService('minorApplicationPlaceResultExcelExport')">{{$t('results')+' EXCEL'}}</b-button>
                        <b-button variant="secondary" @click="runService('minorApplicationPlaceResultPublish')">{{$t('results_publish')}}</b-button>
                        <b-button variant="secondary" @click="runService('minorApplicationPublishResultRegister')">{{$t('registrations_results_publish')}}</b-button>
                        <b-button variant="secondary" @click="runService('minorApplicationAddToArchive')">{{$t('make_archive')}}</b-button>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Component
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"
import CkEditorInput from "@/components/elements/CkEditorInput"

// Services
import ConstantService from "@/services/ConstantService"
import SettingsService from "@/services/SettingsService"

// Other
import {ValidationObserver, ValidationProvider} from "vee-validate";
import qs from "qs";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        SemestersSelectbox,
        CkEditorInput,

        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            formData: {},

        }
    },
    metaInfo() {
        return {
            title: this.$t("settings_minor_application")
        }
    },
    methods: {
        async getSettings() {
            const config = {
                params: {
                    filter: {
                        key: 'minor_application.semester_id,minor_application.start_date,minor_application.end_date,minor_application.registration_sms_message_tr,'+
                            'minor_application.registration_sms_message_en,minor_application.registration_email_message_tr,minor_application.registration_email_message_en'
                    },
                    limit: -1,
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };
            ConstantService.getAll(config).then(response => {
                let data = this.groupBy(response.data.data, 'key')
                this.formData = {
                    semester_id: data['minor_application.semester_id'] ? data['minor_application.semester_id'][0].value : null,
                    start_date: data['minor_application.start_date'] ? data['minor_application.start_date'][0].value : null,
                    end_date: data['minor_application.end_date'] ? data['minor_application.end_date'][0].value : null,
                    sms_message_tr: data['minor_application.registration_sms_message_tr'] ? data['minor_application.registration_sms_message_tr'][0].value : null,
                    sms_message_en: data['minor_application.registration_sms_message_en'] ? data['minor_application.registration_sms_message_en'][0].value : null,
                    mail_message_tr: data['minor_application.registration_email_message_tr'] ? data['minor_application.registration_email_message_tr'][0].value : null,
                    mail_message_en: data['minor_application.registration_email_message_en'] ? data['minor_application.registration_email_message_en'][0].value : null
                }
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        async saveSettings() {
            const isValid = await this.$refs.settingForm.validate();
            if (isValid) {
                ConstantService.updateByKey('minor_application.semester_id', {value: this.formData.semester_id, type: 'semester'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('minor_application.start_date', {value: this.formData.start_date, type: 'date'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('minor_application.end_date', {value: this.formData.end_date, type: 'date'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('minor_application.registration_sms_message_tr', {value: this.formData.sms_message_tr, type: 'string'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('minor_application.registration_sms_message_en', {value: this.formData.sms_message_en, type: 'string'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('minor_application.registration_email_message_tr', {value: this.formData.mail_message_tr, type: 'html'}).catch(e => {
                    this.showErrors(e, null)
                })
                ConstantService.updateByKey('minor_application.registration_email_message_en', {value: this.formData.mail_message_en, type: 'html'}).catch(e => {
                    this.showErrors(e, null)
                })
                this.$toast.success(this.$t('proccess_success'))
            }
        },

        runService(service) {
            SettingsService[service]().then(response => {
                if(service == 'minorApplicationPlaceResultExcelExport'){
                    this.$toast.success(this.$t('proccess_success'))
                    this._downloadFile(response, 'MinorApplicationPlaceResultExcelExport.xlsx')
                } else {
                    this.$toast.success(this.$t('api.'+response.data.message))
                }
            }).catch(e => {
                this.showErrors(e, null)
            })
        }
    },
    created() {
        this.getSettings()
    }
}
</script>
